var _path, _path2, _path3;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgWarningYellow = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1394 1.26607L24.9203 20.1994C25.2601 20.7962 25.2758 21.4778 24.9624 22.0168C24.6491 22.5558 24.052 22.8847 23.3654 22.8847H1.82141C1.13478 22.8847 0.537716 22.5558 0.22437 22.0168C-0.0890618 21.4778 -0.0732664 20.7927 0.266462 20.1959L11.0474 1.26428C11.3895 0.663456 11.9675 0.304688 12.5934 0.304688C13.2194 0.304688 13.7973 0.665249 14.1394 1.26607Z",
    fill: "#FFD600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0166 7.86134C14.0166 7.03614 13.3477 6.36719 12.5225 6.36719C11.6973 6.36719 11.0283 7.03614 11.0283 7.86134V13.2403C11.0283 14.0655 11.6973 14.7345 12.5225 14.7345C13.3477 14.7345 14.0166 14.0655 14.0166 13.2403V7.86134Z",
    fill: "#4D5358"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0878 17.9171C14.0878 17.0919 13.4188 16.423 12.5936 16.423C11.7684 16.423 11.0994 17.0919 11.0994 17.9171C11.0994 18.7423 11.7684 19.4113 12.5936 19.4113C13.4188 19.4113 14.0878 18.7423 14.0878 17.9171Z",
    fill: "#4D5358"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWarningYellow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/warning-yellow.48b1c277.svg";
export { ForwardRef as ReactComponent };